import './styles.css';

const form = document.getElementById('join-form') as HTMLFormElement;
const errorEl = document.getElementById('error') as HTMLParagraphElement;
const submitBtn = form.querySelector('button[type=submit]') as HTMLButtonElement;

const soloForm = document.getElementById('solo-form') as HTMLFormElement;
const soloErrorEl = document.getElementById('solo-error') as HTMLParagraphElement;
const soloSubmitBtn = soloForm.querySelector('button[type=submit]') as HTMLButtonElement;

export const SOLO_TOKEN_KEY = 'naibday-solo-token';

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  errorEl.hidden = true;

  const data = new FormData(form);
  const roomId = String(data.get('roomId') ?? '').trim().toUpperCase();
  const name = String(data.get('name') ?? '').trim();

  if (!roomId || !name) {
    showError('Room ID and name are required.');
    return;
  }

  submitBtn.disabled = true;
  try {
    const resp = await fetch(`/api/rooms/${encodeURIComponent(roomId)}`);
    if (resp.status === 404) {
      throw new Error(`Room ${roomId} doesn't exist.`);
    }
    if (!resp.ok) {
      throw new Error('Server error checking room.');
    }
    const room = (await resp.json()) as { id: string; status: string };
    if (room.status !== 'lobby') {
      throw new Error(`Room ${roomId} is ${room.status} — can't join.`);
    }
    location.href = `/play.html?room=${encodeURIComponent(roomId)}&name=${encodeURIComponent(name)}`;
  } catch (err) {
    showError(err instanceof Error ? err.message : 'Unknown error');
    submitBtn.disabled = false;
  }
});

soloForm.addEventListener('submit', async (e) => {
  e.preventDefault();
  soloErrorEl.hidden = true;

  const data = new FormData(soloForm);
  const password = String(data.get('password') ?? '');
  if (!password) {
    showSoloError('Password is required.');
    return;
  }

  soloSubmitBtn.disabled = true;
  try {
    const resp = await fetch('/api/singleplayer/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    });
    if (resp.status === 401) {
      throw new Error('Wrong password.');
    }
    if (!resp.ok) {
      throw new Error('Server error.');
    }
    const { token } = (await resp.json()) as { token: string };
    sessionStorage.setItem(SOLO_TOKEN_KEY, token);
    location.href = '/play.html?solo=1';
  } catch (err) {
    showSoloError(err instanceof Error ? err.message : 'Unknown error');
    soloSubmitBtn.disabled = false;
  }
});

function showError(msg: string): void {
  errorEl.textContent = msg;
  errorEl.hidden = false;
}

function showSoloError(msg: string): void {
  soloErrorEl.textContent = msg;
  soloErrorEl.hidden = false;
}
